import React from 'react';
import { StyleSheet, Text, TouchableOpacity } from 'react-native';
import { luxColors } from '@alucio/lux-ui/src/theming/themes/legacy/colors';
import DNABox from '@alucio/lux-ui/src/components/layout/DNABox/DNABox';
import Iffy from '@alucio/lux-ui/src/components/util/Iffy/Iffy';
import DNAText from '@alucio/lux-ui/src/components/type/DNAText/DNAText';
import { colors } from '@alucio/lux-ui/src/theming/themes/alucio/colors';
const styles = StyleSheet.create({
    container: {
        maxHeight: 70,
        borderWidth: 1,
        borderRadius: 4,
        marginBottom: 20,
        paddingRight: 16,
    },
    containerChild: {
        width: '100%',
    },
    title: {
        marginLeft: 16,
        marginRight: 16,
        marginTop: 10,
        marginBottom: 10,
        fontSize: 14,
        width: '100%',
        fontWeight: 'normal',
        lineHeight: 20,
        whiteSpace: 'inherit',
    },
});
const titleVariance = {
    primary: { color: luxColors.primary.primary },
    success: { color: luxColors.success.primary },
    warning: { color: luxColors.warning.quaternary },
    danger: { color: luxColors.error.primary },
    darkWarning: { color: luxColors.warning.quaternary },
};
const containerVariance = {
    primary: {
        backgroundColor: luxColors.primary.tertiary,
        borderColor: luxColors.primary.primary,
    },
    danger: {
        backgroundColor: colors['danger-transparent-100'],
        borderColor: luxColors.error.primary,
    },
    success: {
        backgroundColor: luxColors.success.secondary,
        borderColor: luxColors.success.primary,
    },
    warning: {
        backgroundColor: luxColors.warning.quinary,
        borderColor: luxColors.warning.quaternary,
    },
    darkWarning: {
        backgroundColor: luxColors.warning.senary,
        borderColor: luxColors.warning.quaternary,
    },
};
export default function InformationMessage(props) {
    const { actionButtonFunction, actionButtonText, text, variance = 'primary', leftIcon } = props;
    return (<DNABox appearance="row" spacing="between" alignY="center" fill childStyle={styles.containerChild} style={[styles.container, containerVariance[variance], props.style]}>
      <DNABox alignY="center">
        {leftIcon}
        <Text style={[styles.title, titleVariance[variance]]}>
          {text}
        </Text>
        <Iffy is={actionButtonFunction && actionButtonText}>
          <TouchableOpacity onPress={actionButtonFunction}>
            <DNAText bold style={titleVariance[variance]}>
              {actionButtonText}
            </DNAText>
          </TouchableOpacity>
        </Iffy>

      </DNABox>
    </DNABox>);
}
//# sourceMappingURL=InformationMessage.js.map